export function getType(doc) {
    return doc["@patchwork"]?.type;
}
export function getSuggestedImportUrl(doc) {
    return doc["@patchwork"]?.suggestedImportUrl;
}
export function getCopies(doc) {
    return doc["@patchwork"]?.copies || [];
}
export function getCopyOf(doc) {
    return doc["@patchwork"]?.copyOf;
}
